module.exports = __webpack_public_path__ + "static/img/sec1-slide-img02@w.8864427.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/transys/sec1-slide-img02@w.jpg
// module id = wV8l
// module chunks = 0